"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useRowSelectOnClick = void 0;
const react_1 = require("react");
const utilities_1 = require("./utilities");
function useRowSelectOnClick(hooks) {
    const [selectionStartId, setSelectionStartId] = react_1.useState("");
    const onClick = (event, clickedRow, instance) => {
        const thisRowAlreadySelected = clickedRow.isSelected;
        const selectionModeProp = "selectionMode";
        switch (instance.selectionMode) {
            case "Single":
                if (thisRowAlreadySelected) {
                    clickedRow.toggleRowSelected();
                    setSelectionStartId("");
                }
                else {
                    instance.toggleAllRowsSelected(false);
                    clickedRow.toggleRowSelected();
                    setSelectionStartId(clickedRow.id);
                }
                break;
            case "Multi":
                setSelectionStartId(thisRowAlreadySelected ? "" : clickedRow.id);
                clickedRow.toggleRowSelected();
                break;
            case "MultiWithCtrlShift":
                const otherRowSelected = selectionStartId && selectionStartId !== clickedRow.id;
                // Ctrl and row already selected - de-select
                if (event.ctrlKey && thisRowAlreadySelected) {
                    clickedRow.toggleRowSelected();
                }
                // Ctrl and row not already selected - select and start range
                else if (event.ctrlKey) {
                    clickedRow.toggleRowSelected();
                    setSelectionStartId(clickedRow.id);
                }
                // Shift and range started on other row - select whole range
                else if (event.shiftKey && otherRowSelected) {
                    const limitIds = [selectionStartId, clickedRow.id];
                    for (const [row, isInRange] of DetectRange(instance.rows, row => limitIds.includes(row.id))) {
                        row.toggleRowSelected(isInRange);
                    }
                }
                // Everything else, select this row only and start range
                else {
                    instance.toggleAllRowsSelected(false);
                    clickedRow.toggleRowSelected();
                    setSelectionStartId(clickedRow.id);
                }
                break;
            default:
                throw new Error(`Select-row-on-click requires table option '${selectionModeProp}'`);
        }
    };
    hooks.getRowProps.push((rowProps, { row, instance }) => {
        if (!utilities_1.IsSelectableRow(row)) {
            throw new Error("Row is not selectable. Ensure the `useRowSelect' plugin is added before this one.");
        }
        const rowSelectInstance = instance;
        return Object.assign(Object.assign({}, rowProps), { onClick: (event) => onClick(event, row, rowSelectInstance), onDoubleClick: () => rowSelectInstance.onRowDblClick ? rowSelectInstance.onRowDblClick(row.original) : {} });
    });
}
exports.useRowSelectOnClick = useRowSelectOnClick;
function* DetectRange(items, isLimit) {
    let position = "BeforeRange";
    for (const item of items) {
        if (position === "WithinRange") {
            yield [item, true];
            if (isLimit(item)) {
                position = "AfterRange";
            }
        }
        else if (position === "BeforeRange") {
            if (isLimit(item)) {
                position = "WithinRange";
                yield [item, true];
            }
            else {
                yield [item, false];
            }
        }
        else {
            yield [item, false];
        }
    }
}
//# sourceMappingURL=row-select-on-click.js.map